import { useState, useEffect } from 'react';
import { T } from 'gt-react';
import { Label } from 'src/components/ui/label';
import { Textarea } from 'src/components/ui/textarea';

export function parsePatterns(text: string): string[] {
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
}

export function patternsToText(
  patterns: string[] | readonly string[] | undefined,
): string {
  return (patterns ?? []).join('\n');
}

export function PatternEditor({
  label,
  description,
  patterns,
  onChange,
}: {
  label: string;
  description: string;
  patterns: string[] | undefined;
  onChange: (patterns: string[]) => void;
}) {
  const [text, setText] = useState(patternsToText(patterns));
  const latestPatterns = patternsToText(patterns);

  // Sync from parent when patterns change externally
  useEffect(() => {
    setText(latestPatterns);
  }, [latestPatterns]);

  return (
    <div className="space-y-1.5">
      <Label className="text-xs font-medium">{label}</Label>
      <Textarea
        className="font-mono text-xs"
        rows={Math.max(2, text.split('\n').length + 1)}
        placeholder={description}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onBlur={() => onChange(parsePatterns(text))}
      />
      <p className="text-[11px] text-muted-foreground">
        <T context="Hint for multi-line pattern textarea in workflow config">
          One pattern per line. Supports regex (case-insensitive).
        </T>
      </p>
    </div>
  );
}
